/** Browser entity intent; independent of data loading and viewport. */
export type EntityTarget = { kind: "doc" | "issue" | "note"; id: string };
export type EntityRoute = { target: EntityTarget | null; invalid: boolean };

export function readEntityRoute(href: string): EntityRoute {
  const url = new URL(href, "https://pauta.invalid");
  const docs = url.searchParams.getAll("doc");
  const issues = url.searchParams.getAll("issue");
  const notes = url.searchParams.getAll("note");
  if (!docs.length && !issues.length && !notes.length) return { target: null, invalid: false };
  if (docs.length + issues.length + notes.length !== 1) return { target: null, invalid: true };
  const kind = docs.length ? "doc" : notes.length ? "note" : "issue";
  const rawId = (docs[0] ?? notes[0] ?? issues[0]).trim();
  const id = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(rawId) ? rawId.toLowerCase() : rawId;
  return id ? { target: { kind, id }, invalid: false } : { target: null, invalid: true };
}

export function entityRouteUrl(href: string, target: EntityTarget | null, view?: string): string {
  const url = new URL(href, "https://pauta.invalid");
  url.searchParams.delete("doc");
  url.searchParams.delete("issue");
  url.searchParams.delete("note");
  if (target) {
    url.searchParams.set(target.kind, target.id);
    url.searchParams.delete("task_nav");
    url.searchParams.delete("project");
    url.searchParams.delete("team_home");
  }
  if (target?.kind === "doc") url.hash = "docs";
  else if (target?.kind === "note") url.hash = "notes";
  else if (view) url.hash = view;
  return `${url.pathname}${url.search}${url.hash}`;
}
